export const CITIES = ['Lisbon', 'Porto'];

export const TIME_CHIPS = [
  { id: 'live', label: 'Live now' },
  { id: 'tonight', label: 'Tonight' },
  { id: 'week', label: 'This week' },
  { id: 'new', label: 'New' },
];

export const CATEGORY_CHIPS = [
  { id: 'all', label: 'All' },
  { id: 'sports', label: 'Live sports' },
  { id: 'concerts', label: 'Concerts' },
  { id: 'nightlife', label: 'Nightlife' },
  { id: 'culture', label: 'Culture' },
  { id: 'free', label: 'Free' },
];

export const GENRES = ['Football', 'Electronic', 'Indie & Alt', 'Fado'];

export const SEARCH_STAGES = [
  'Looking up live and upcoming…',
  'Reading Lisbon and Portugal listings…',
  'Matching tonight, this week, and live…',
];

export const EVENTS = [
  {
    id: 'sporting-braga',
    title: 'Sporting vs Braga',
    meta: 'Sport TV 1',
    city: 'Lisbon',
    category: 'sports',
    windows: ['live', 'tonight'],
    status: 'live',
    heat: 1840,
    reminds: 126,
    art: '#1d4ed8',
    genre: 'Football',
    place: 'Alvalade',
  },
  {
    id: 'ibai-stream',
    title: 'Ibai — Just Chatting',
    meta: 'Twitch',
    city: 'Lisbon',
    category: 'nightlife',
    windows: ['live'],
    status: 'live',
    heat: 12400,
    reminds: 48,
    art: '#7c3aed',
    genre: 'Electronic',
    place: 'Online',
    global: true,
  },
  {
    id: 'candlelight',
    title: 'Candlelight: Vivaldi',
    meta: 'Starting 21:00',
    city: 'Lisbon',
    category: 'culture',
    windows: ['tonight', 'week'],
    status: 'soon',
    heat: 312,
    reminds: 88,
    art: '#b45309',
    genre: 'Fado',
    place: 'Igreja de São Roque',
  },
  {
    id: 'musicbox',
    title: 'Lunar Isles (live)',
    meta: 'Musicbox',
    city: 'Lisbon',
    category: 'concerts',
    windows: ['tonight', 'week'],
    status: 'soon',
    heat: 540,
    reminds: 71,
    art: '#0f766e',
    genre: 'Indie & Alt',
    place: 'Cais do Sodré',
  },
  {
    id: 'bairro-dj',
    title: 'Bairro Alto late set',
    meta: '23:30 · club',
    city: 'Lisbon',
    category: 'nightlife',
    windows: ['tonight'],
    status: 'soon',
    heat: 276,
    reminds: 34,
    art: '#9f1239',
    genre: 'Electronic',
    place: 'Bairro Alto',
  },
  {
    id: 'alfama-fado',
    title: 'Fado in Alfama',
    meta: 'Free · 20:00',
    city: 'Lisbon',
    category: 'free',
    windows: ['tonight', 'week'],
    status: 'free',
    heat: 198,
    reminds: 41,
    art: '#365314',
    genre: 'Fado',
    place: 'Alfama',
  },
  {
    id: 'timeout-picks',
    title: 'Lisbon weekend picks',
    meta: 'Editorial list · 12 events',
    city: 'Lisbon',
    category: 'culture',
    windows: ['week', 'new'],
    status: 'soon',
    heat: 90,
    reminds: 210,
    art: '#1e3a5f',
    genre: 'Indie & Alt',
    place: 'Citywide',
    listCount: 12,
  },
  {
    id: 'nos-warmup',
    title: 'NOS Alive warmup',
    meta: 'Fri · Parque das Nações',
    city: 'Lisbon',
    category: 'concerts',
    windows: ['week', 'new'],
    status: 'soon',
    heat: 960,
    reminds: 402,
    art: '#155e75',
    genre: 'Indie & Alt',
    place: 'Passeio Marítimo',
  },
  {
    id: 'benfica-gil',
    title: 'Benfica vs Gil Vicente',
    meta: 'Sun 18:00 · Benfica TV',
    city: 'Lisbon',
    category: 'sports',
    windows: ['week'],
    status: 'soon',
    heat: 720,
    reminds: 155,
    art: '#991b1b',
    genre: 'Football',
    place: 'Estádio da Luz',
  },
  {
    id: 'porto-moreirense',
    title: 'FC Porto vs Moreirense',
    meta: 'Sport TV 1',
    city: 'Porto',
    category: 'sports',
    windows: ['live', 'tonight'],
    status: 'live',
    heat: 1510,
    reminds: 99,
    art: '#1e3a8a',
    genre: 'Football',
    place: 'Dragão',
  },
  {
    id: 'casa-musica',
    title: 'Electronic night',
    meta: 'Casa da Música',
    city: 'Porto',
    category: 'concerts',
    windows: ['tonight', 'week'],
    status: 'soon',
    heat: 410,
    reminds: 67,
    art: '#4c1d95',
    genre: 'Electronic',
    place: 'Boavista',
  },
  {
    id: 'porto-free',
    title: 'Ribeira street session',
    meta: 'Free · dusk',
    city: 'Porto',
    category: 'free',
    windows: ['tonight', 'week', 'new'],
    status: 'free',
    heat: 122,
    reminds: 19,
    art: '#3f6212',
    genre: 'Indie & Alt',
    place: 'Ribeira',
  },
];

export function filterEvents({ city, time, category, query }) {
  const q = (query || '').trim().toLowerCase();
  return EVENTS.filter((event) => {
    if (!event.global && event.city !== city) return false;
    if (time && !event.windows.includes(time)) return false;
    if (category && category !== 'all' && event.category !== category) return false;
    if (q) {
      const hay = `${event.title} ${event.meta} ${event.place} ${event.genre}`.toLowerCase();
      if (!hay.includes(q)) return false;
    }
    return true;
  }).sort((a, b) => b.heat - a.heat);
}

export function followUps({ city, time, query }) {
  const chips = [
    `Tonight in ${city}`,
    'Free events',
    'Live sports',
  ];
  if (query) chips.unshift(`Similar to ${query}`);
  if (time === 'week') chips.push('This weekend only');
  return chips.slice(0, 4);
}
